/*
 * Module for the topic label modal
 */

define([
  "marionette",
  "jquery",
  "underscore",
  "backbone",
  "messaging/messenger",
  "./contentAndLearnerView",
  "modules/accountAdmin/privilegeEnum",
  "modules/accountAdmin/kbRoleAdmin/kbRoleModel",
], function (
  Marionette,
  $,
  _,
  Backbone,
  Messenger,
  ContentAndLearnerView,
  PrivilegeEnum,
  KbRoleModel,
) {
  return Marionette.Controller.extend({
    initialize: function (options) {
      this.region = options.region;
      this.name = "contentAndLearnerModule";
    },
    show: function (kbRole, kb) {
      this.kbRole = kbRole;
      this._createModelFromRole();
      this.model.kb = kb;
      this.view = new ContentAndLearnerView.contentAndLearnerView({ model: this.model });

      this.view.on(
        "click:enableContentTab",
        function () {
          this.model.set("enableContentTab", !this.model.get("enableContentTab"));
          this.view.render();
        },
        this,
      );

      this.view.on(
        "click:enableLearnerTab",
        function () {
          this.model.set("enableLearnerTab", !this.model.get("enableLearnerTab"));
          this.view.render();
        },
        this,
      );

      this.view.on(
        "click:enableSubstitutionsTab",
        function () {
          this.model.set("enableSubstitutionsTab", !this.model.get("enableSubstitutionsTab"));
          this.view.render();
        },
        this,
      );

      this.view.on(
        "click:taskCreate",
        function () {
          this.model.set("taskCreate", !this.model.get("taskCreate"));
          this.view.render();
        },
        this,
      );

      this.view.on(
        "click:editAnyTask",
        function () {
          this.model.set("anyTaskEdit", !this.model.get("anyTaskEdit"));
          this.view.render();
        },
        this,
      );

      this.view.on(
        "click:responseReview",
        function () {
          this.model.set("responseReview", !this.model.get("responseReview"));
          this.view.render();
        },
        this,
      );

      this.showRegion(this.view);
    },
    _createModelFromRole: function () {
      this.model = new Backbone.Model({
        enableContentTab: false,
        enableLearnerTab: false,
        enableSubstitutionsTab: false,
        taskCreate: false,
        anyTaskEdit: false,
        responseReview: false,
      });
      this.kbRole.privileges().each(function (privilege) {
        switch (privilege.get("privId")) {
          case PrivilegeEnum.ContentTab:
            this.model.set("enableContentTab", true);
            this.model.enableContentTabPrivilege = privilege;
            break;
          case PrivilegeEnum.LearnerTab:
            this.model.set("enableLearnerTab", true);
            this.model.enableLearnerTabPrivilege = privilege;
            break;
          case PrivilegeEnum.SubstitutionsTab:
            this.model.set("enableSubstitutionsTab", true);
            this.model.enableSubstitutionsTabPrivilege = privilege;
            break;
          case PrivilegeEnum.TaskCreate:
            this.model.set("taskCreate", true);
            this.model.taskCreatePrivilege = privilege;
            break;
          case PrivilegeEnum.AnyTaskEdit:
            this.model.set("anyTaskEdit", true);
            this.model.anyTaskEditPrivilege = privilege;
            break;
          case PrivilegeEnum.ResponseReview:
            this.model.set("responseReview", true);
            this.model.responseReviewPrivilege = privilege;
        }
      }, this);
    },
    _createPrivilege: function (privId) {
      return new KbRoleModel.kbRolePrivilege({
        kbRoleId: this.kbRole.get("id"),
        privId: privId,
        privName: PrivilegeEnum.getPrivilegeName(privId),
      });
    },
    getPrivileges: function () {
      let privilege;
      let newPrivileges = [];
      if (this.model.get("enableContentTab")) {
        privilege = this.model.enableContentTabPrivilege;
        if (!privilege) {
          privilege = this._createPrivilege(PrivilegeEnum.ContentTab);
          this.model.enableContentTabPrivilege = privilege;
        }
        newPrivileges.push(privilege);
      }
      if (this.model.get("enableLearnerTab")) {
        privilege = this.model.enableLearnerTabPrivilege;
        if (!privilege) {
          privilege = this._createPrivilege(PrivilegeEnum.LearnerTab);
          this.model.enableLearnerTabPrivilege = privilege;
        }
        newPrivileges.push(privilege);
      }
      if (this.model.get("enableSubstitutionsTab")) {
        privilege = this.model.enableSubstitutionsTabPrivilege;
        if (!privilege) {
          privilege = this._createPrivilege(PrivilegeEnum.SubstitutionsTab);
          this.model.enableSubstitutionsTabPrivilege = privilege;
        }
        newPrivileges.push(privilege);
      }
      if (this.model.get("taskCreate")) {
        privilege = this.model.taskCreatePrivilege;
        if (!privilege) {
          privilege = this._createPrivilege(PrivilegeEnum.TaskCreate);
          this.model.taskCreatePrivilege = privilege;
        }
        newPrivileges.push(privilege);
      }
      if (this.model.get("anyTaskEdit")) {
        privilege = this.model.anyTaskEditPrivilege;
        if (!privilege) {
          privilege = this._createPrivilege(PrivilegeEnum.AnyTaskEdit);
          this.model.anyTaskEditPrivilege = privilege;
        }
        newPrivileges.push(privilege);
      }
      if (this.model.get("responseReview")) {
        privilege = this.model.responseReviewPrivilege;
        if (!privilege) {
          privilege = this._createPrivilege(PrivilegeEnum.ResponseReview);
          this.model.responseReviewPrivilege = privilege;
        }
        newPrivileges.push(privilege);
      }
      return newPrivileges;
    },
  });
});
